module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/theme2-0d5d2bb2f221e3649ecd3ec5b86735b3.png";